export const USER_ROLES = {
    ADMINISTRATOR: 'Administrator',
    CLINICAL_LIAISON: 'Clinical Liaison',
    ENGINEERING: 'Engineering',
    EXTERNAL: 'External',
    SUPPORT: 'Support',
    SUPERVISOR: 'Supervisor',
}